import { buildDemoStudentsForClass } from "./buildDemoStudents";

function parseIso(s) {
  if (s == null || s === "") {
    return null;
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Horários do aluno (GET Academics/student/schedule/:studentId?start&end).
 * Formato alinhado a getStudentSchedule no waybee-api.
 */
export function buildDemoStudentSchedule(studentId, startStr, endStr) {
  const demo = buildDemoStudentsForClass("DEMO-T1");
  if (!demo.some(x => String(x.ra) === String(studentId))) {
    return [];
  }

  const start = parseIso(startStr);
  const end = parseIso(endStr);
  if (!start || !end) {
    return [];
  }

  const mid = new Date((start.getTime() + end.getTime()) / 2);
  const day = mid.toISOString().slice(0, 10);

  return [
    {
      title: "DEMO-T1 - Português — demonstração",
      description: "DEMO",
      start: `${day}T08:00:00`,
      end: `${day}T09:00:00`,
      color: "#00b2b9",
      textColor: "black"
    },
    {
      title: "DEMO-T1 - Matemática — demonstração",
      description: "DEMO",
      start: `${day}T09:15:00`,
      end: `${day}T10:15:00`,
      color: "#00b2b9",
      textColor: "black"
    }
  ];
}
